import { render } from "./EmployeeApproveServiceReports.vue?vue&type=template&id=453a6ab6"
import script from "./EmployeeApproveServiceReports.vue?vue&type=script&lang=js"
export * from "./EmployeeApproveServiceReports.vue?vue&type=script&lang=js"

import "./EmployeeApproveServiceReports.vue?vue&type=style&index=0&id=453a6ab6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__